import { isToolUIPart } from "ai";
import type { ChatMessage } from "@tracify/shared";

export type ToolCallApprovalActionInput = {
  approvalId: string;
};

export type PendingToolCallApproval = {
  approvalId: string;
  toolCallId: string;
  args: unknown;
};

export function getPendingToolCallApprovalMap(
  parts: ChatMessage["parts"] | undefined
) {
  const approvals = new Map<string, PendingToolCallApproval>();

  for (const part of parts ?? []) {
    if (!isToolUIPart(part) || part.state !== "approval-requested") {
      continue;
    }

    if (!part.approval?.id) {
      continue;
    }

    approvals.set(part.toolCallId, {
      approvalId: part.approval.id,
      toolCallId: part.toolCallId,
      args: part.input,
    });
  }

  return approvals;
}
